import React from 'react';

import { makeStyles } from 'tss-react/mui';

import { getListingCardTitle } from '@ha/core/Listing/getListingCardTitle';
import { Typography } from '@hbf/dsl/core';

import { useIntl } from 'ha/i18n';
import { ListingCardModel } from 'ha/models/Listing/types';

const useStyles = makeStyles()(() => ({
  container: {
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

interface ListingCardDetailsTitleProps {
  listing: ListingCardModel;
}

export const ListingCardDetailsTitle = React.memo(
  ({ listing }: ListingCardDetailsTitleProps) => {
    const { T } = useIntl();
    const { classes } = useStyles();

    const title = getListingCardTitle(
      {
        city: listing.location.city.en,
        street: listing.location.street,
        propertyType: listing.space.propertyType,
        recordType: listing.identifiers.recordType,
        facility_co_living: listing.space.coLiving ? 'yes' : 'no',
        facility_student_housing: listing.space.studentHousing ? 'yes' : 'no',
      },
      T,
    );

    return (
      <Typography
        variant="body/md-semibold"
        className={classes.container}
        data-test-locator="ListingCard/Title"
      >
        {title}
      </Typography>
    );
  },
);
